module.exports = __webpack_public_path__ + "loading.703f935c30dd1dbc01d9.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/images/loading.png
// module id = ../../../../../src/assets/images/loading.png
// module chunks = 5